const Rose = {
  Rose: {
    _600: '#E11D48',
  },
};

export default Rose;
